import { api } from "../../services/NetworkBase";

export async function GetAllEmailTemplates(searchText = "") { 
  try {
    let response = await api
      .get(`vlp/email-templates?searchText=${searchText}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetEmailTemplateById(templateId) {
  try {
    let response = await api.get(`vlp/email-templates/${templateId}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateEmailTemplate(template) {  
  try {
    let response = await api.put("vlp/email-templates", { json: template });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveEmailTemplate(template) {
  try {
    let response = await api.post("vlp/email-templates", { json: template });
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteEmailTemplate(templateId) {
  try {
    const encodedUrl = encodeURIComponent(templateId);
    let response = await api
      .delete(`vlp/email-templates/${encodedUrl}`)
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}